import styled from 'styled-components';
import MenuItem from '../MenuItem';

const DashboardMenu = styled(MenuItem)`
  padding: 18px 26px 18px;
  font-size: 20px;
`;

export default DashboardMenu;
